import React, { useState } from "react";
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import { makeStyles } from '@material-ui/core/styles';


const useStyles = makeStyles((theme) => ({
    tab: {
        textTransform: "none",
        minWidth: "50px",
        fontSize: "12px",
        height: "30px",
        backgroundColor: "#DBE6E0",
        color:"#222",
        borderLeft: "#eee 1px solid",
        opacity: 1
    }
    }));


  function TabPanel(props) {
    const { children, value, index, ...other } = props;
  
    return (
      <div
        role="tabpanel"
        hidden={value !== index}
        id={`simple-tabpanel-${index}`}
        aria-labelledby={`simple-tab-${index}`}
        {...other}
        className="tabpanel"
        style={{height: props.height, ...props.style}}
      >
        {value === index && (
            children
        )}
      </div>
    );
  }

function TabMenu(props){

    const classes = useStyles()
    const {id, labels} = props;
    const [visibleTab, setVisibleTab] = useState(0)

    const handleTabs= (event, newValue) => {
      setVisibleTab(newValue)
    };


    return(
      <div className={"lead-tabs"}>
        <Tabs
        key={id}
        value={visibleTab}
        onChange={handleTabs}
        variant={"fullWidth"}
        TabIndicatorProps={{style: {backgroundColor: "#3B5158"}}}
        >
      
        {labels.map((label, i)=> <Tab key={id+"-tab-"+i} disabled={props.loading || label.disabled} disableRipple label={label.label} classes={{root: classes.tab, disabled: classes.tab}}/>)}
      </Tabs>
      {props.children.map((child, i)=> <TabPanel key={id+"-tabpanel-"+i} value={visibleTab} index={i} height={props.height} style={{...props.style}}>{child}</TabPanel>)}
     </div>
    )

}

export {TabMenu}